export var bookapiRoomCateringUpsellingActionTypes;
(function (bookapiRoomCateringUpsellingActionTypes) {
    bookapiRoomCateringUpsellingActionTypes["INITIAL_BOOKAPI_ROOM_CATERING_RATE_STATE"] = "INITIAL_BOOKAPI_ROOM_CATERING_RATE_STATE";
    bookapiRoomCateringUpsellingActionTypes["RECEIVE_BOOKAPI_ROOM_CATERING_RATE_STATE"] = "RECEIVE_BOOKAPI_ROOM_CATERING_RATE_STATE";
    bookapiRoomCateringUpsellingActionTypes["RECEIVE_BOOKAPI_ROOM_CATERING_RATE_FAILED"] = "RECEIVE_BOOKAPI_ROOM_CATERING_RATE_FAILED";
})(bookapiRoomCateringUpsellingActionTypes || (bookapiRoomCateringUpsellingActionTypes = {}));
export var initialBookapiRoomCateringUpsellingStateAction = {
    type: bookapiRoomCateringUpsellingActionTypes.INITIAL_BOOKAPI_ROOM_CATERING_RATE_STATE
};
